var modal_setup = null;
Event.observe(document, 'modal:open', function(){
	//stuff in here should be removed.  it would be much cleaner to put it in the body of the smarty template.
	//(if you want to see if it being loaded by the modalbox[aka: prototype's ajax], you can do if {is_xhr}...{/if} )
	//or when you call open modal you can do open_modal(todo, {afterLoad: function(){...}})
	//and pass the stuff you want it to do when it opens to it directly (see the documentation on open_modal)

	var MB_content = $('MB_content');
	if(!MB_content)
		return;
	var form = MB_content.down('form');
	if(form)
		form.mox = new MoxForm(form,true);
	if(form){
		var valid = new Validation(form);
	}

	/*if($('additional_contact')){
		var new_row = $('additional_contact').innerHTML;
		$('additional_contact').remove();
	}*/
	MB_content.select('.format_date').each(function(e){
		dateSetup();
		e.observe('keyup', dateSetup);
		e.observe('blur', function(){
			// handle defaults
			dateSetup();
		});
		document.observe('date:fire', dateSetup);
		//e.observe('modal:validate', repeat_form($('frequency')));
	});

	// automatically set up the autocomplete field (if it exists)
	var a = $('autocomplete_choices');
	if(a && $('abt')){ // We only want to do this on the notes and task modals.  If it happens anywhere else (like the supply checkout) it will break since there is no #abt element
		var rel = a.getAttribute('rel');
		new Ajax.Autocompleter('abt', "autocomplete_choices", "ajax/", {
			parameters: 'table=autocomplete_'+($('MB_caption').innerHTML.toLowerCase().match('note')?'notes':'company'),
			minChars: 2,
			indicator: 'indicator1',
			frequency: 0.4,
			afterUpdateElement: function(textInput, li){
				if(modal_setup)
					modal_setup(textInput, li);
				else
					if(li.up('div').getAttribute('rel'))
						$(li.up('div').getAttribute('rel')).value= li.id.substr(3);
			}
		});
	}
});

function show_dialog({text, title, icon, footer, cancelButton, primaryButton, ...options}) {
    return new Promise((resolve) => {
        let body = ``;

        if (icon) {
			const icon_style = options.iconStyle ?? '';
            body += `<i class="${icon}" style="margin-bottom: 2rem; ${icon_style}"></i>`;
        }

        if (text) {
            body += `<p style="font-size: 1.1rem; font-weight: normal; line-height: 1.5rem;">${text}</p>`;
        }
        const buttons = [];

        if (!cancelButton) {
            cancelButton = {show: true, text: 'Cancel', class: ''};
        }
        const modal_id = GUI.get_num();
        if (cancelButton && cancelButton.show) {
            const btn_class = cancelButton.class ?? '';
            const btn_text = cancelButton.text ?? '';
            const btn_style = cancelButton.style ?? '';
            buttons.push(`<button type="button" class="am-btn am-btn--text ${btn_class}" style="${btn_style}" data-type="cancel">${btn_text}</button>`);
        }

        if (primaryButton) {
            const btn_class = primaryButton.class ?? '';
            const btn_text = primaryButton.text ?? '';
			const btn_style = primaryButton.style ?? '';
            buttons.push(`<button type="button" class="am-btn am-btn--filled ${btn_class}" style="${btn_style}" data-type="primary">${btn_text}</button>`);
        }

        if (buttons.length > 0) {
            body += `<div class="am-dialog__actions" style="justify-content: center; gap: 1rem;">${buttons.join('')}</div>`;
        }

		if (footer) {
			body += footer;
		}

        title = title ?? ' ';

        body = `<div style="text-align: center; padding-top: 2rem;" id="modal_${modal_id}">${body}</div>`;

        options.x_click = () => {
            resolve({dismiss: true});
        }

        open_modal(body, {title, ...options});

		const retry_modal = setInterval(() => {
			const $modal_content = am.$('#modal_' + modal_id);
			if ($modal_content.length > 0) {
				clearInterval(retry_modal);
				$modal_content.parent().css('padding', '0 40px 20px 40px');
			}
		}, 100);

		am.$(document.body).on('click', '#modal_' + modal_id + ' button[data-type]', function (e) {
            if (e.target.getAttribute('data-type') === 'primary') {
				resolve({confirm: true, dismiss: false});
            } else {
				resolve({confirm: false, dismiss: false});
            }

            if ($('MB_close')) {
                $('MB_close').click();
            }
        });
    });
}

/**
 * Helper function for Modalbox.  URI paths are relative the the website base.  (The modalbox library could use a serious overhaul.)
 * Note:  Multiple modal boxes cannot exist at the same time, so this function has been modified to try to automatically close an open modal before proceeding.
 * @param object|string	todo	If a string:
 *									  * If HTML:  Modal content to display.
 *									  * If a URI, modal content will be retrieved from the specified location.
 *									If an object, use the following members:
 *									  * string	href:	Path to modal content to display.  Will only be used for retrieving content if options.uri is omitted, in which case '&modal=1' will be added.
 *									  * string	title:	Modal title.  If omitted and not specified by options.title, a title will be generated from todo.href if it is defined.
 * @param object		options		The following members are all optional:
 *									  * boolean	grabControlOfNotifications:	Display notifications in the modal.
 *									  * string	title:	Modal title.  Supercedes todo.title.
 *									  * string	uri:	Path to modal content to display.  Supercedes todo.herf.
 *									  * See Modalbox.Methods for more options not directly acted upon here.
 */
function open_modal(todo, options){
	if(!todo) return;
	options = options || { };
	if(!options.uri && todo.href){
		options.uri = todo.href+'&modal=1'; // This assumes the URI already contains parameters!
	} else {
		options.uri = todo //this allows you to pass a string like '<div>somecontent</div>' or a html element to be shown in the modalbox via modalboxe's native show.
	}
	if(!options.title){
		if(options.translation_var){
			options.title = get_language_translation(options.translation_var);
		}
		else if(todo.title){
			options.title = todo.title;
		}
		else if(todo.href){
			var arr = todo.href.replace($$('base')[0].href,'').split('/');
			todo.table = arr[0];
			todo.action = arr[1];
			options.title = force_initial_caps(todo.action+' '+todo.table);
			if(am.$(todo).data('modaltitle')){
				options.title = am.$(todo).data('modaltitle');
			}
		}
	}
	if(options.width && options.width > am.$('body').width()){
		options.width = am.$('body').width()-20;
	}
	if(am.$('body').hasClass('device_ismobile_true') && typeof options.width === "undefined"){
		options.width = am.$('body').width()-20;
	}
	var _afterLoad = options.afterLoad;
	options.afterLoad = function(){
		Element.fire(document, 'modal:open');
		try{
			if(options.grabControlOfNotifications){
				MB_content.insert({
					top: $('notifications').update() //do update here to clear the notifications before you stick it in the modal.
				});
			}
		}
		catch(e){
		}
		
		if(typeof _afterLoad == "function"){
			_afterLoad(); //pass along anthing caller put in options.afterLoad.
		}
	}
	var _beforeHide = options.beforeHide;
	options.beforeHide = function(){
		if($('maincontent') && options.grabControlOfNotifications){
			$('maincontent').insert({before: $('notifications')});
		}
		if(typeof _beforeHide == "function"){
			_beforeHide(); //pass along anthing caller put in options.beforeLoad.
		}
	}
	// When the modal box is closed, it slowly fades away then is removed from the DOM.  If you happen to call for another modal box
	// before this action completes, the second call will, at best, replace the content of the first modal box just before it disappears.
	// Here, an interval function is used as a workaround.  (A better solution might be to rewrite modalbox.js so that modal box elements
	// are dynamically ID'd and handled, allowing for multiple concurrent instances.)
	if(!Modalbox.initialized)
		Modalbox.show(options.uri, options);
	else
	{
		if($('MB_close'))
			$('MB_close').click();
		var retry_modal = setInterval(function()
		{
			if(!Modalbox.initialized)
			{
				clearInterval(retry_modal);
				Modalbox.show(options.uri, options);
			}
		}, 100);
	}
	return false;
}

// !! Todo: This function can be cleaned up a lot more as the dismissable calls are always via Anchor element to public/customer_terms/ or orders/customer_terms/,
// !! and the non-dismissable call is currently only one case via submitting a public order.
function terms_and_conditions(caller, callback, dismissable, uri){
	if ( dismissable ) {
		// Modal displayed not tied to order submission; caller should be an Anchor element
		Modalbox.show(caller.href, {
			title : "Terms and Conditions"
		});
	} else {
		// Modal displayed when submitting an order; caller should be a FORM element (this block appears to only be used by public order form)
		var mox = $(caller).tagName.toUpperCase() === 'FORM' ? $(caller).mox : $(caller).up('form').mox;
		mox.reset();

		callback(mox);
		if(!mox.failed)
			open_modal(uri, {
				title : "Order Confirmation",
				x_click: function() { if(!window.submit_order_accept_terms) re_enable_order_submission_buttons(); }
			});
	}

	return false;
}
function force_initial_caps(st){
	var caps = true;
	for(var i = 0; i < st.length; i++){
		var char = st.slice(i,i+1);
		if(char == '_'){
			st = st.slice(0,i)+' '+st.slice(i+1,999999);
			caps = true;
		} else if(!caps && char == ' '){
			caps = true;
		} else if(!caps && "ABCDEFGHIJKLMNOPQRSTUVWXYZ".indexOf(char)>-1){
			st = st.slice(0,i)+' '+st.slice(i,999999);
		} else if(caps && "abcdefghijklmnopqrstuvwxyz".indexOf(char)>-1){
			st = st.slice(0,i)+char.toUpperCase()+st.slice(i+1,999999);
			caps = false;
		}
	}
	return st;
}
// Confirmation for deletion of an object out of the database.
// Use key_field and explicit_id if automatic key identification doesn't work.  Stupid changes made because I'm sick and starving, and nobody tested this feature when it was completed ages ago; I'll revisint after to optimize after release.
function confirm_form_delete(obj,typ,key_field,explicit_id){
	if(confirm(get_language_translation('LANG_ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_' + typ.toUpperCase()))){
		var uri = obj.href;
		var id = key_field ? key_field : typ+'_id';
		if(uri && uri.length){
			var params = {};
			params[id] = explicit_id ? explicit_id : obj.up('div,tr').id.replace((typ+'_'),'');
			new Ajax.Request(uri, {
				method : 'post',
				parameters : params
			});
		}
		GUI.remove_div($(obj).up('div,tr'))
		if(typ == 'location'){
			add_notification(typ[0].toUpperCase() + typ.slice(1)+' '+get_language_translation('LANG_DELETED_SUCCESSFULLY'));
		}
	}
	return false;
}
function confirm_delete_clock(log, ajaxy) {
	var tr = $(log).up('tr');
	var id = tr.id.match(/\d+$/).pop();
	if(confirm(get_language_translation('LANG_ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_CLOCK'))){
		if(ajaxy){
			new Ajax.Request('worklog/delete/'+id+'/', {
				parameters : { 'log' : id, 'ajax' : 1 },
				onSuccess : function(ret){
					tr.next().remove();	// remove the row for editing
					tr.remove();		// remove the row itself
					add_notification(get_language_translation('LANG_MSG_CLOCK_DELETED_SUCCESSFULLY'), 'success');
					$('results').down('tbody').childElements().each(function(e,i){
						if(!(parseInt(i/2)%2)) e.removeClassName('even');
						else e.addClassName('even');
					})
				}
			});
		} else {
			var form = (new Element('form',{'id':'delete_confirm_clock','method':'post','action':'worklog/delete/'+id+'/'}))
				.insert(new Element('input',{'type':'hidden','name':'log','value':id}));
			document.body.appendChild(form);
			document.forms["delete_confirm_clock"].submit();
		}
	}
	return false;
}
// Confirmation for a form element collapse
function confirm_delete(obj, typ, auto, custom) {
	var t   = obj.href.split('/');
	var id  = t[t.length-2];
	var delMsg = '';
	if((typ == 'payment method') || (typ == 'Schedule Event')){
		var str = typ.replace(" " , "_")
		delMsg = get_language_translation('LANG_ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_' + str.toUpperCase());
	}else{
		delMsg = get_language_translation('LANG_ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_' + typ.toUpperCase());
	}
	if(typ === 'task') {
		delMsg = get_language_translation('LANG_ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_TASK');
	}
	if (delMsg === 'Undefined') {
		delMsg = "";
	}
	if(auto || confirm(delMsg + (custom ? ' ' + custom : ''))){
		var form = (new Element('form',{'id':'delete_confirm_'+id,'method':'post','action':obj.href}))
			.insert(new Element('input',{'type':'hidden','id':typ+'_id','name':typ+'_id','value':id}));
		document.body.appendChild(form);
		document.forms['delete_confirm_'+id].submit();
	}
	return false;
}

// I do not belive this func is still being used - M.Yandow 02/13/23
function confirm_delete_element(label, element, callback) {
	if (confirm("Are you sure you want to delete this " + label + "?")) {
		$(element).remove();
		if (typeof callback === 'function') {
			callback();
		}
	}
	return false;
}

// I do not belive this func is still being used - M.Yandow 02/13/23
function confirmation(obj){
	var t   = obj.ele.href.split('/');
	var id  = obj.id || t[t.length-2];
	if(!id || !Number(id)) return;
	var typ = obj.type || (t[t.length-4].slice(-3)=='ies' ? t[t.length-4].slice(0,-1) : t[t.length-4].slice(0,-3)+'y') ;
	var act = obj.act || obj.ele.href.replace(document.getElementsByTagName('base')[0].href,'');
	var key = obj.key || typ;
	if(confirm("Are you sure you want to delete this "+typ+"?")){
		var form = (new Element('form',{'id':'delete_confirm_'+id,'method':'post','action':act}))
			.insert(new Element('input',{'type':'hidden','id':key+'_id','name':key+'_id','value':id}));
		document.body.appendChild(form);
		document.forms["delete_confirm_"+id].submit();
	}
	return false;
}
function confirm_cancel(obj, typ, auto)
{
	var t   = obj.href.split('/');
	var id  = t[t.length-2];
	if(auto || confirm(get_language_translation('LANG_ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_' + typ.toUpperCase()))){
		var form = (new Element('form',{'id':'delete_confirm_'+id,'typ':'delete_confirm_'+id,'method':'post','action':obj.href}))
			.insert(new Element('input',{'type':'hidden','id':typ+'_id','name':typ+'_id','value':id}));
		document.body.appendChild(form);
		document.forms["delete_confirm_"+id].submit();
	}
	return false;
}
function get_premium(el) {
	var mox = el.up('form').mox;
	mox.failed = false;
	mox.require('cc_name','Enter a name.');
	mox.require('cc_num','Enter a card number.');
	mox.require('cc_cvv2','Enter a cvv2 code.');
	mox.require('billme','You must check the box.');
	if(!mox.failed){
		new Ajax.Request(el.href, {
			parameters : el.up('form').serialize(),
			onSuccess: function(ret) {
				window.location.reload();
			},
			onFailure: function(ret) {
				add_notification(ret.responseJSON.msg, 'danger');
			}
		});
	}
	return false;
}
function enable_scanning_extra(ev) {
	$$('.extra-input > div').invoke('hide');
	var to_show = ev.element().value;
	if ($(to_show))
		$(to_show).show();
}
function enter_scan(ev) {
	Event.stop(ev);
	var el = ev.element();

		new Ajax.Request(el.readAttribute('action'), {
			parameters : el.serialize(),
			onSuccess : function(ret){

				if(ret.responseJSON.color && ret.responseJSON.color == 3)
					add_temp_notification(ret.responseJSON.msg, 'error')
				else if(ret.responseJSON.color && ret.responseJSON.color == 2)
					add_temp_notification(ret.responseJSON.msg, 'notice');
				else
					add_temp_notification(ret.responseJSON.msg, 'success');
				var action = $F('action');
				if(ret.responseJSON.color==0){
					$('shipping_alert').value='1';
				}

				var shipping_alert = $F('shipping_alert');
				if (action == 'completed_checkoff') {
					$('shipping_input').focus();
					if(shipping_alert == 1)
						$('shipping_input').value = '';
				}
				else if (action == 'change_order_staus') {
					$('change_order_id').focus().value = '';
				}
				else if (action == 'process') {
					if ($F('end_order_id').length > 0) {
						$('end_order_id').value = '';
						$('start_order_id').value = '';
						$('start_order_id').focus();
					}
					else {
						$('end_order_id').focus();
					}
				}
				else if (action == 'process_completed') {
					$('order_id').focus();
					if(shipping_alert == 1)
						$('order_id').value = '';
				}
				else if(action == 'shipped'){
					$('order_shipping_id').focus();
					if(shipping_alert == 1)
						$('order_shipping_id').value = '';
					}
			}
		});
	
}
function change_line(el) {
	el = $(el);
	new Ajax.Request('ajax/get_processes/', {
		parameters : {"line_id":el.value},
		onSuccess : function(ret) {
			if (el.id == 'line') {
				var procsel = build_select('process','process1',ret.responseJSON);
				procsel.addClassName('same_width_as_text MB_focusable');
				$('process1').replace(procsel);
			}
			else if (el.id == 'line2') {
				var procsel = build_select('process2','process2',ret.responseJSON);
				procsel.addClassName('same_width_as_text MB_focusable');
				$('process2').replace(procsel);
			}
		}
	});
}
function update_order_status(ev) { //this one is for the order page
	Event.stop(ev);
	var el = ev.element();
	new Ajax.Request(el.readAttribute('action'), {
		parameters : el.serialize(),
		onSuccess : function(ret){
			if($('MB_close'))
				$('MB_close').click();
			$('status').down('b').update(ret.responseJSON.newStatus);
			setTimeout(function() {
			if (ret.responseJSON.success.length)
				add_temp_notification(ret.responseJSON.success, 'success');
			if (ret.responseJSON.debug.length)
				add_temp_notification(ret.responseJSON.debug, 'notice');
			if (ret.responseJSON.error.length)
				add_temp_notification(ret.responseJSON.error, 'danger');
			},1000);

		}
	});

}
function open_modal_notice(message, notification_type)
{
	notification_type = notification_type || 'notice';
	var notification = '<p class="' + notification_type + '">' + message + '</p>';
	open_modal(notification, { ok: true });
}
